import React from "react";

export default function CollectionBanner({
  categoryTitle,
  bannerImage = "https://manybooks.net/sites/default/files/2018-07/bookcoverssmall2.jpg",
}) {
  return (
    <section
      style={{
        backgroundImage: `url(${bannerImage})`,
      }}
      className="relative min-h-[220px] lg:min-h-[320px] flex items-center bg-cover bg-center bg-no-repeat border-b border-secondary/25"
    >
      {/* Immersive radial/linear dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-black via-black/85 md:via-black/70 to-transparent z-0"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-14 py-8">
        <div className="max-w-2xl text-center sm:text-left">
          <span className="text-secondary text-xs sm:text-sm font-bold uppercase tracking-widest mb-1.5 block">
            Explore Collection
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight font-outfit">
            Discover Your Favorite
            <span className="block mt-2 font-extrabold text-secondary capitalize text-4xl sm:text-5xl lg:text-6.5xl tracking-wide">
              {categoryTitle}
            </span>
          </h1>
        </div>
      </div>
    </section>
  );
}

